import { SignIn, SignUp } from "@clerk/react";
import { Gauge, Mail, ShieldCheck } from "lucide-react";
import { ThemeToggle } from "@/lib/theme";

const IMG = "/hero-kupfer.jpg";

const Brand = () => (
  <div className="hidden lg:flex relative w-1/2 flex-col justify-start gap-16 overflow-hidden p-12">
    <img src={IMG} alt="Kupferrohre" className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: "85% 70%" }} />
    <div className="brand-overlay absolute inset-0 bg-gradient-to-r from-[#F7F1E8] via-[#F7F1E8]/85 to-[#F7F1E8]/10" />
    <div className="relative flex items-center gap-3 text-slate-900">
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-600 font-display text-lg font-bold text-white">Cu</div>
      <span className="font-display text-xl font-semibold tracking-tight">KupferRadar</span>
    </div>
    <div className="relative max-w-md space-y-6 text-slate-900">
      <h1 className="text-4xl font-bold tracking-tight lg:text-5xl">Kupferkurse im Blick. Bevor der Markt sich dreht.</h1>
      <ul className="space-y-3 text-slate-700">
        <li className="flex items-center gap-3"><Gauge className="h-4 w-4 text-orange-600" /> Börsenkurs & Richtpreise je Reinheit</li>
        <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-orange-600" /> Preisalarm mit Entwicklungsreport per E-Mail</li>
        <li className="flex items-center gap-3"><ShieldCheck className="h-4 w-4 text-orange-600" /> Zugang nur für freigeschaltete Benutzer</li>
      </ul>
    </div>
  </div>
);

const Shell = ({ children }) => (
  <div className="relative flex min-h-screen" data-testid="auth-page">
    <ThemeToggle className="absolute right-4 top-4 z-10" />
    <Brand />
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-10">
      <div className="flex items-center gap-2 lg:hidden">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-600 font-display font-bold text-white">Cu</div>
        <span className="font-display text-lg font-semibold">KupferRadar</span>
      </div>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <Shell>
    <SignIn routing="path" path="/sign-in" appearance={{ elements: { footerAction: { display: "none" } } }} />
  </Shell>
);

export const SignUpPage = () => (
  <Shell>
    <p className="max-w-sm text-center text-sm text-slate-500" data-testid="signup-admin-note">Einmalige Einrichtung des Administrator-Kontos. Andere Konten werden ausschließlich vom Administrator angelegt.</p>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </Shell>
);
